module.exports = __webpack_public_path__ + "accounting.e2b181765efdf6e4db52.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/bgs/accounting.jpg
// module id = 264
// module chunks = 2